"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var users = [{
  id: 1,
  username: "ed__8888",
  rank: 1,
  points: 6
}, {
  id: 2,
  username: "fab665",
  rank: 2,
  points: 5
}, {
  id: 3,
  username: "jasonholder",
  rank: 2,
  points: 5
}, {
  id: 4,
  username: "lucydan_xx",
  rank: 3,
  points: 4
}, {
  id: 5,
  username: "slicktricks",
  rank: 3,
  points: 4
}, {
  id: 6,
  username: "legendzclub",
  rank: 4,
  points: 3
}];
var _default = users;
exports.default = _default;